<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import { BaseBtn, type BaseBtnProps } from '@/ui/base';

  export type MarkerPillSubDim =
    | 'subdim1'
    | 'subdim2'
    | 'subdim3'
    | 'subdim4'
    | 'subdim5'
    | 'subdim6'
    | 'subdim7';

  export interface AdditionalProps {
    variant: MarkerPillSubDim;
    value: number;
    percentage?: boolean;
  }

  export type MarkerPillProps = AdditionalProps & BaseBtnProps;
</script>

<script lang="ts">
  const styles = tv({
    base: 'rounded-sm px-2 py-1 text-label-xs text-c-base',
    variants: {
      variant: {
        subdim1: 'bg-subdim-1',
        subdim2: 'bg-subdim-2',
        subdim3: 'bg-subdim-3',
        subdim4: 'bg-subdim-4',
        subdim5: 'bg-subdim-5',
        subdim6: 'bg-subdim-6',
        subdim7: 'bg-subdim-7',
      },
      selected: {
        false: 'font-normal',
        true: 'font-semibold',
      },
      disabled: {
        false: '',
        true: '!bg-neutral text-c-light',
      },
    },
  });

  let {
    variant = 'subdim1',
    selected = $bindable(false),
    disabled = false,
    label,
    percentage,
    value = 0,
    class: className,
    onclick: btnClicked,
    ...props
  }: MarkerPillProps = $props();

  let roundedValue = $derived(Math.round(value));
  let isDisabled = $derived(roundedValue === 0 || disabled === true);
  let isSelected = $derived(!isDisabled && selected);

  // Generate used classes
  let cn: string = $derived(
    styles({
      variant,
      selected: isSelected,
      disabled: isDisabled,
      className,
    }),
  );
  let percentageString: string = $derived(percentage ? '%' : '');
</script>

<BaseBtn
  class={cn}
  {...props}
  disabled={isDisabled}
  selected={false}
  onclick={(event) => {
    selected = !selected;
    if (btnClicked) btnClicked(event);
  }}
>
  {label}: <strong class="font-semibold">{roundedValue}{percentageString}</strong>
</BaseBtn>
